import { SvgIconProps, ListItem, ListItemIcon } from '@mui/material';
import { ExtendedListItemButton, ExtendedListItemText } from '@procureai/ui-mui';
import { ComponentType } from 'react';

interface ChatRequestOptionProps {
  title: string;
  description: string;
  Icon: ComponentType<SvgIconProps>;
  onClick?: () => void;
  disabled?: boolean;
}

export const ChatRequestOption = ({ title, description, disabled, Icon, onClick }: ChatRequestOptionProps) => {
  return (
    // NOTES:
    // we are overwriting the list design to be "white" according to design spec (default is gray)
    // button is deprecated (ListItemButton is the new name but not extended in ui lib yet)
    // ListItemIcon here does not have the minWidth as in lib / storybook
    <ListItem disablePadding sx={(theme) => ({ boxShadow: theme.shadows[2] })}>
      <ExtendedListItemButton
        sx={(theme) => ({ backgroundColor: theme.palette.background.paper })}
        onClick={onClick}
        disabled={disabled}
      >
        <ListItemIcon sx={{ minWidth: 40 }}>
          <Icon />
        </ListItemIcon>
        <ExtendedListItemText primary={title} secondary={description} />
      </ExtendedListItemButton>
    </ListItem>
  );
};
